import { Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconButton } from '@angular/material/button';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-notes-button',
  templateUrl: './notes-button.component.html',
  styleUrls: ['./notes-button.component.scss'],
  imports: [TranslateModule, MatIconButton, MatTooltip, MatIcon],
})
export class NotesButtonComponent {
  @Input() hasCount = false;

  constructor() {}
}
